// Campaign Actions
import axios from 'axios';
import config from '../../config';
import { getUserToken } from '../../utils/helpers';

export const GET_CAMPAIGNS = 'GET_CAMPAIGNS';
export const GET_CAMPAIGNS_SUCCESS = 'GET_CAMPAIGNS_SUCCESS';
export const GET_CAMPAIGNS_FAIL = 'GET_CAMPAIGNS_FAIL';
export const GET_CAMPAIGNS_RESET = 'GET_CAMPAIGNS_RESET';

export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const CREATE_CAMPAIGN_SUCCESS = 'CREATE_CAMPAIGN_SUCCESS';
export const CREATE_CAMPAIGN_FAIL = 'CREATE_CAMPAIGN_FAIL';
export const CREATE_CAMPAIGN_RESET = 'CREATE_CAMPAIGN_RESET';

export const GET_CAMPAIGN_BY_ID = 'GET_CAMPAIGN_BY_ID';
export const GET_CAMPAIGN_BY_ID_SUCCESS = 'GET_CAMPAIGN_BY_ID_SUCCESS';
export const GET_CAMPAIGN_BY_ID_FAIL = 'GET_CAMPAIGN_BY_ID_FAIL';
export const GET_CAMPAIGN_BY_ID_RESET = 'GET_CAMPAIGN_BY_ID_RESET';

export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const UPDATE_CAMPAIGN_SUCCESS = 'UPDATE_CAMPAIGN_SUCCESS';
export const UPDATE_CAMPAIGN_FAIL = 'UPDATE_CAMPAIGN_FAIL';
export const UPDATE_CAMPAIGN_RESET = 'UPDATE_CAMPAIGN_RESET';

export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const DELETE_CAMPAIGN_SUCCESS = 'DELETE_CAMPAIGN_SUCCESS';
export const DELETE_CAMPAIGN_FAIL = 'DELETE_CAMPAIGN_FAIL';
export const DELETE_CAMPAIGN_RESET = 'DELETE_CAMPAIGN_RESET';

export const PUBLISH_CAMPAIGN = 'PUBLISH_CAMPAIGN';
export const PUBLISH_CAMPAIGN_SUCCESS = 'PUBLISH_CAMPAIGN_SUCCESS';
export const PUBLISH_CAMPAIGN_FAIL = 'PUBLISH_CAMPAIGN_FAIL';
export const PUBLISH_CAMPAIGN_RESET = 'PUBLISH_CAMPAIGN_RESET';

// PureSpectrum Integration Action Types
export const PUBLISH_TO_PURESPECTRUM = 'PUBLISH_TO_PURESPECTRUM';
export const PUBLISH_TO_PURESPECTRUM_SUCCESS = 'PUBLISH_TO_PURESPECTRUM_SUCCESS';
export const PUBLISH_TO_PURESPECTRUM_FAIL = 'PUBLISH_TO_PURESPECTRUM_FAIL';
export const PUBLISH_TO_PURESPECTRUM_RESET = 'PUBLISH_TO_PURESPECTRUM_RESET';

export const LAUNCH_CAMPAIGN = 'LAUNCH_CAMPAIGN';
export const LAUNCH_CAMPAIGN_SUCCESS = 'LAUNCH_CAMPAIGN_SUCCESS';
export const LAUNCH_CAMPAIGN_FAIL = 'LAUNCH_CAMPAIGN_FAIL';
export const LAUNCH_CAMPAIGN_RESET = 'LAUNCH_CAMPAIGN_RESET';

export const PAUSE_CAMPAIGN = 'PAUSE_CAMPAIGN';
export const PAUSE_CAMPAIGN_SUCCESS = 'PAUSE_CAMPAIGN_SUCCESS';
export const PAUSE_CAMPAIGN_FAIL = 'PAUSE_CAMPAIGN_FAIL';
export const PAUSE_CAMPAIGN_RESET = 'PAUSE_CAMPAIGN_RESET';

export const RESUME_CAMPAIGN = 'RESUME_CAMPAIGN';
export const RESUME_CAMPAIGN_SUCCESS = 'RESUME_CAMPAIGN_SUCCESS';
export const RESUME_CAMPAIGN_FAIL = 'RESUME_CAMPAIGN_FAIL';
export const RESUME_CAMPAIGN_RESET = 'RESUME_CAMPAIGN_RESET';

export const CLOSE_CAMPAIGN = 'CLOSE_CAMPAIGN';
export const CLOSE_CAMPAIGN_SUCCESS = 'CLOSE_CAMPAIGN_SUCCESS';
export const CLOSE_CAMPAIGN_FAIL = 'CLOSE_CAMPAIGN_FAIL';
export const CLOSE_CAMPAIGN_RESET = 'CLOSE_CAMPAIGN_RESET';

export const FORCE_CLOSE_CAMPAIGN = 'FORCE_CLOSE_CAMPAIGN';
export const FORCE_CLOSE_CAMPAIGN_SUCCESS = 'FORCE_CLOSE_CAMPAIGN_SUCCESS';
export const FORCE_CLOSE_CAMPAIGN_FAIL = 'FORCE_CLOSE_CAMPAIGN_FAIL';
export const FORCE_CLOSE_CAMPAIGN_RESET = 'FORCE_CLOSE_CAMPAIGN_RESET';

export const SYNC_CAMPAIGN = 'SYNC_CAMPAIGN';
export const SYNC_CAMPAIGN_SUCCESS = 'SYNC_CAMPAIGN_SUCCESS';
export const SYNC_CAMPAIGN_FAIL = 'SYNC_CAMPAIGN_FAIL';
export const SYNC_CAMPAIGN_RESET = 'SYNC_CAMPAIGN_RESET';

export const UPDATE_CPI = 'UPDATE_CPI';
export const UPDATE_CPI_SUCCESS = 'UPDATE_CPI_SUCCESS';
export const UPDATE_CPI_FAIL = 'UPDATE_CPI_FAIL';
export const UPDATE_CPI_RESET = 'UPDATE_CPI_RESET';

export const GET_PS_STATS = 'GET_PS_STATS';
export const GET_PS_STATS_SUCCESS = 'GET_PS_STATS_SUCCESS';
export const GET_PS_STATS_FAIL = 'GET_PS_STATS_FAIL';
export const GET_PS_STATS_RESET = 'GET_PS_STATS_RESET';

// Campaign Calls Action Types
export const GET_CAMPAIGN_CALLS = 'GET_CAMPAIGN_CALLS';
export const GET_CAMPAIGN_CALLS_SUCCESS = 'GET_CAMPAIGN_CALLS_SUCCESS';
export const GET_CAMPAIGN_CALLS_FAIL = 'GET_CAMPAIGN_CALLS_FAIL';
export const GET_CAMPAIGN_CALLS_RESET = 'GET_CAMPAIGN_CALLS_RESET';

export const GET_CALL_TRANSCRIPT = 'GET_CALL_TRANSCRIPT';
export const GET_CALL_TRANSCRIPT_SUCCESS = 'GET_CALL_TRANSCRIPT_SUCCESS';
export const GET_CALL_TRANSCRIPT_FAIL = 'GET_CALL_TRANSCRIPT_FAIL';
export const GET_CALL_TRANSCRIPT_RESET = 'GET_CALL_TRANSCRIPT_RESET';

export const GET_TRANSCRIPT_STATS = 'GET_TRANSCRIPT_STATS';
export const GET_TRANSCRIPT_STATS_SUCCESS = 'GET_TRANSCRIPT_STATS_SUCCESS';
export const GET_TRANSCRIPT_STATS_FAIL = 'GET_TRANSCRIPT_STATS_FAIL';
export const GET_TRANSCRIPT_STATS_RESET = 'GET_TRANSCRIPT_STATS_RESET';

export const PROCESS_CAMPAIGN_TRANSCRIPTS = 'PROCESS_CAMPAIGN_TRANSCRIPTS';
export const PROCESS_CAMPAIGN_TRANSCRIPTS_SUCCESS = 'PROCESS_CAMPAIGN_TRANSCRIPTS_SUCCESS';
export const PROCESS_CAMPAIGN_TRANSCRIPTS_FAIL = 'PROCESS_CAMPAIGN_TRANSCRIPTS_FAIL';
export const PROCESS_CAMPAIGN_TRANSCRIPTS_RESET = 'PROCESS_CAMPAIGN_TRANSCRIPTS_RESET';

export const RETRY_FAILED_TRANSCRIPTS = 'RETRY_FAILED_TRANSCRIPTS';
export const RETRY_FAILED_TRANSCRIPTS_SUCCESS = 'RETRY_FAILED_TRANSCRIPTS_SUCCESS';
export const RETRY_FAILED_TRANSCRIPTS_FAIL = 'RETRY_FAILED_TRANSCRIPTS_FAIL';
export const RETRY_FAILED_TRANSCRIPTS_RESET = 'RETRY_FAILED_TRANSCRIPTS_RESET';

export const UPDATE_CALL_QUALITY = 'UPDATE_CALL_QUALITY';
export const UPDATE_CALL_QUALITY_SUCCESS = 'UPDATE_CALL_QUALITY_SUCCESS';
export const UPDATE_CALL_QUALITY_FAIL = 'UPDATE_CALL_QUALITY_FAIL';
export const UPDATE_CALL_QUALITY_RESET = 'UPDATE_CALL_QUALITY_RESET';

export const GET_CALL_AUDIO = 'GET_CALL_AUDIO';
export const GET_CALL_AUDIO_SUCCESS = 'GET_CALL_AUDIO_SUCCESS';
export const GET_CALL_AUDIO_FAIL = 'GET_CALL_AUDIO_FAIL';
export const GET_CALL_AUDIO_RESET = 'GET_CALL_AUDIO_RESET';

// Refresh Call Item (audio or transcript)
export const REFRESH_CALL_ITEM = 'REFRESH_CALL_ITEM';
export const REFRESH_CALL_ITEM_SUCCESS = 'REFRESH_CALL_ITEM_SUCCESS';
export const REFRESH_CALL_ITEM_FAIL = 'REFRESH_CALL_ITEM_FAIL';
export const REFRESH_CALL_ITEM_RESET = 'REFRESH_CALL_ITEM_RESET';

// Reprocess Call
export const REPROCESS_CALL = 'REPROCESS_CALL';
export const REPROCESS_CALL_SUCCESS = 'REPROCESS_CALL_SUCCESS';
export const REPROCESS_CALL_FAIL = 'REPROCESS_CALL_FAIL';
export const REPROCESS_CALL_RESET = 'REPROCESS_CALL_RESET';

// Bulk Reprocess Calls
export const BULK_REPROCESS_CALLS = 'BULK_REPROCESS_CALLS';
export const BULK_REPROCESS_CALLS_SUCCESS = 'BULK_REPROCESS_CALLS_SUCCESS';
export const BULK_REPROCESS_CALLS_FAIL = 'BULK_REPROCESS_CALLS_FAIL';
export const BULK_REPROCESS_CALLS_RESET = 'BULK_REPROCESS_CALLS_RESET';

// Toggle Call Star
export const TOGGLE_CALL_STAR = 'TOGGLE_CALL_STAR';
export const TOGGLE_CALL_STAR_SUCCESS = 'TOGGLE_CALL_STAR_SUCCESS';
export const TOGGLE_CALL_STAR_FAIL = 'TOGGLE_CALL_STAR_FAIL';
export const TOGGLE_CALL_STAR_RESET = 'TOGGLE_CALL_STAR_RESET';

// Eleven Labs Credits
export const GET_ELEVENLABS_CREDITS = 'GET_ELEVENLABS_CREDITS';
export const GET_ELEVENLABS_CREDITS_SUCCESS = 'GET_ELEVENLABS_CREDITS_SUCCESS';
export const GET_ELEVENLABS_CREDITS_FAIL = 'GET_ELEVENLABS_CREDITS_FAIL';
export const GET_ELEVENLABS_CREDITS_RESET = 'GET_ELEVENLABS_CREDITS_RESET';

// Action Creators
export const getCampaigns = (params) => ({
  type: GET_CAMPAIGNS,
  params,
});

export const getCampaignsSuccess = (response) => ({
  type: GET_CAMPAIGNS_SUCCESS,
  response,
});

export const getCampaignsFail = (response) => ({
  type: GET_CAMPAIGNS_FAIL,
  response,
});

export const getCampaignsReset = () => ({
  type: GET_CAMPAIGNS_RESET,
});

export const createCampaign = (params) => ({
  type: CREATE_CAMPAIGN,
  params,
});

export const createCampaignSuccess = (response) => ({
  type: CREATE_CAMPAIGN_SUCCESS,
  response,
});

export const createCampaignFail = (response) => ({
  type: CREATE_CAMPAIGN_FAIL,
  response,
});

export const createCampaignReset = () => ({
  type: CREATE_CAMPAIGN_RESET,
});

export const getCampaignById = (params) => ({
  type: GET_CAMPAIGN_BY_ID,
  params,
});

export const getCampaignByIdSuccess = (response) => ({
  type: GET_CAMPAIGN_BY_ID_SUCCESS,
  response,
});

export const getCampaignByIdFail = (response) => ({
  type: GET_CAMPAIGN_BY_ID_FAIL,
  response,
});

export const getCampaignByIdReset = () => ({
  type: GET_CAMPAIGN_BY_ID_RESET,
});

export const updateCampaign = (params) => ({
  type: UPDATE_CAMPAIGN,
  params,
});

export const updateCampaignSuccess = (response) => ({
  type: UPDATE_CAMPAIGN_SUCCESS,
  response,
});

export const updateCampaignFail = (response) => ({
  type: UPDATE_CAMPAIGN_FAIL,
  response,
});

export const updateCampaignReset = () => ({
  type: UPDATE_CAMPAIGN_RESET,
});

export const deleteCampaign = (params) => ({
  type: DELETE_CAMPAIGN,
  params,
});

export const deleteCampaignSuccess = (response) => ({
  type: DELETE_CAMPAIGN_SUCCESS,
  response,
});

export const deleteCampaignFail = (response) => ({
  type: DELETE_CAMPAIGN_FAIL,
  response,
});

export const deleteCampaignReset = () => ({
  type: DELETE_CAMPAIGN_RESET,
});

export const publishCampaign = (params) => ({
  type: PUBLISH_CAMPAIGN,
  params,
});

export const publishCampaignSuccess = (response) => ({
  type: PUBLISH_CAMPAIGN_SUCCESS,
  response,
});

export const publishCampaignFail = (response) => ({
  type: PUBLISH_CAMPAIGN_FAIL,
  response,
});

export const publishCampaignReset = () => ({
  type: PUBLISH_CAMPAIGN_RESET,
});

// Thunk Actions
export const getCampaignsApi = (data) => {
  return (dispatch) => {
    dispatch(getCampaigns());
    axios
      .get(`${config.api.base_url}/campaigns`, {
        params: data,
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        const getCampaignsData = response.data;
        dispatch(getCampaignsSuccess(getCampaignsData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(getCampaignsFail(error.response?.data || errorMsg));
      });
  };
};

// Create Campaign
export const createCampaignApi = (data) => {
  return (dispatch) => {
    dispatch(createCampaign());
    axios
      .post(`${config.api.base_url}/campaigns`, data, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        const createCampaignData = response.data;
        dispatch(createCampaignSuccess(createCampaignData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(createCampaignFail(error.response?.data || errorMsg));
      });
  };
};

// Get Campaign By ID
export const getCampaignByIdApi = (id) => {
  return (dispatch) => {
    dispatch({ type: GET_CAMPAIGN_BY_ID });
    axios
      .get(`${config.api.base_url}/campaigns/${id}`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        const getCampaignByIdData = response.data;
        dispatch(getCampaignByIdSuccess(getCampaignByIdData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(getCampaignByIdFail(error.response?.data || errorMsg));
      });
  };
};

// Update Campaign
export const updateCampaignApi = (id, data) => {
  return (dispatch) => {
    dispatch(updateCampaign());
    axios
      .post(`${config.api.base_url}/campaigns/${id}`, data, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        const updateCampaignData = response.data;
        dispatch(updateCampaignSuccess(updateCampaignData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(updateCampaignFail(error.response?.data || errorMsg));
      });
  };
};

// Delete Campaign
export const deleteCampaignApi = (id) => {
  return (dispatch) => {
    dispatch(deleteCampaign());
    axios
      .post(`${config.api.base_url}/campaigns/delete/${id}`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        const deleteCampaignData = response.data;
        dispatch(deleteCampaignSuccess(deleteCampaignData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(deleteCampaignFail(error.response?.data || errorMsg));
      });
  };
};

// Publish Campaign
export const publishCampaignApi = (id) => {
  return (dispatch) => {
    dispatch(publishCampaign());
    axios
      .post(`${config.api.base_url}/campaigns/publish/${id}`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        const publishCampaignData = response.data;
        dispatch(publishCampaignSuccess(publishCampaignData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(publishCampaignFail(error.response?.data || errorMsg));
      });
  };
};

// Get Campaign By Link (public endpoint, no auth required)
export const getCampaignByLinkApi = (slug, code) => {
  return (dispatch) => {
    dispatch({ type: GET_CAMPAIGN_BY_ID });
    axios
      .get(`${config.api.base_url}/campaigns/link/${slug}/${code}`)
      .then((response) => {
        const getCampaignByLinkData = response.data;
        dispatch(getCampaignByIdSuccess(getCampaignByLinkData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(getCampaignByIdFail(error.response?.data || errorMsg));
      });
  };
};

// ============== PureSpectrum Integration Thunk Actions ==============

// Publish to PureSpectrum
export const publishToPureSpectrumApi = (id) => {
  return (dispatch) => {
    dispatch({ type: PUBLISH_TO_PURESPECTRUM });
    axios
      .post(`${config.api.base_url}/campaigns/purespectrum/publish/${id}`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: PUBLISH_TO_PURESPECTRUM_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: PUBLISH_TO_PURESPECTRUM_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const publishToPureSpectrumReset = () => ({
  type: PUBLISH_TO_PURESPECTRUM_RESET,
});

// Launch Campaign
export const launchCampaignApi = (id) => {
  return (dispatch) => {
    dispatch({ type: LAUNCH_CAMPAIGN });
    axios
      .post(`${config.api.base_url}/campaigns/purespectrum/launch/${id}`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: LAUNCH_CAMPAIGN_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: LAUNCH_CAMPAIGN_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const launchCampaignReset = () => ({
  type: LAUNCH_CAMPAIGN_RESET,
});

// Pause Campaign
export const pauseCampaignApi = (id) => {
  return (dispatch) => {
    dispatch({ type: PAUSE_CAMPAIGN });
    axios
      .post(`${config.api.base_url}/campaigns/purespectrum/pause/${id}`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: PAUSE_CAMPAIGN_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: PAUSE_CAMPAIGN_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const pauseCampaignReset = () => ({
  type: PAUSE_CAMPAIGN_RESET,
});

// Resume Campaign
export const resumeCampaignApi = (id) => {
  return (dispatch) => {
    dispatch({ type: RESUME_CAMPAIGN });
    axios
      .post(`${config.api.base_url}/campaigns/purespectrum/resume/${id}`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: RESUME_CAMPAIGN_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: RESUME_CAMPAIGN_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const resumeCampaignReset = () => ({
  type: RESUME_CAMPAIGN_RESET,
});

// Close Campaign
export const closeCampaignApi = (id) => {
  return (dispatch) => {
    dispatch({ type: CLOSE_CAMPAIGN });
    axios
      .post(`${config.api.base_url}/campaigns/purespectrum/close/${id}`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: CLOSE_CAMPAIGN_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: CLOSE_CAMPAIGN_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const closeCampaignReset = () => ({
  type: CLOSE_CAMPAIGN_RESET,
});

// Force Close Campaign
export const forceCloseCampaignApi = (id) => {
  return (dispatch) => {
    dispatch({ type: FORCE_CLOSE_CAMPAIGN });
    axios
      .post(`${config.api.base_url}/campaigns/force-close/${id}`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: FORCE_CLOSE_CAMPAIGN_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: FORCE_CLOSE_CAMPAIGN_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const forceCloseCampaignReset = () => ({
  type: FORCE_CLOSE_CAMPAIGN_RESET,
});

// Sync Campaign
export const syncCampaignApi = (id) => {
  return (dispatch) => {
    dispatch({ type: SYNC_CAMPAIGN });
    axios
      .post(`${config.api.base_url}/campaigns/purespectrum/sync/${id}`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: SYNC_CAMPAIGN_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: SYNC_CAMPAIGN_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const syncCampaignReset = () => ({
  type: SYNC_CAMPAIGN_RESET,
});

// Update CPI
export const updateCPIApi = (id, cpi) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_CPI });
    axios
      .post(`${config.api.base_url}/campaigns/purespectrum/update-cpi/${id}`, { cpi }, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: UPDATE_CPI_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: UPDATE_CPI_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const updateCPIReset = () => ({
  type: UPDATE_CPI_RESET,
});

// Get PureSpectrum Stats
export const getPureSpectrumStatsApi = (id) => {
  return (dispatch) => {
    dispatch({ type: GET_PS_STATS });
    axios
      .get(`${config.api.base_url}/campaigns/purespectrum/stats/${id}`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: GET_PS_STATS_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: GET_PS_STATS_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const getPureSpectrumStatsReset = () => ({
  type: GET_PS_STATS_RESET,
});

// ============== Campaign Calls Thunk Actions ==============

// Get Campaign Calls
export const getCampaignCallsApi = (campaignId, params = {}) => {
  return (dispatch) => {
    dispatch({ type: GET_CAMPAIGN_CALLS });
    axios
      .get(`${config.api.base_url}/campaigns/${campaignId}/calls`, {
        params,
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: GET_CAMPAIGN_CALLS_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: GET_CAMPAIGN_CALLS_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const getCampaignCallsReset = () => ({
  type: GET_CAMPAIGN_CALLS_RESET,
});

// Get Call Transcript
export const getCallTranscriptApi = (campaignId, callId, trigger = false) => {
  return (dispatch) => {
    dispatch({ type: GET_CALL_TRANSCRIPT });
    axios
      .get(`${config.api.base_url}/campaigns/${campaignId}/calls/${callId}/transcript`, {
        params: { trigger: trigger ? 'true' : 'false' },
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: GET_CALL_TRANSCRIPT_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: GET_CALL_TRANSCRIPT_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const getCallTranscriptReset = () => ({
  type: GET_CALL_TRANSCRIPT_RESET,
});

// Get Transcript Stats
export const getTranscriptStatsApi = (campaignId) => {
  return (dispatch) => {
    dispatch({ type: GET_TRANSCRIPT_STATS });
    axios
      .get(`${config.api.base_url}/campaigns/${campaignId}/calls/stats`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: GET_TRANSCRIPT_STATS_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: GET_TRANSCRIPT_STATS_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const getTranscriptStatsReset = () => ({
  type: GET_TRANSCRIPT_STATS_RESET,
});

// Process Campaign Transcripts
export const processCampaignTranscriptsApi = (campaignId) => {
  return (dispatch) => {
    dispatch({ type: PROCESS_CAMPAIGN_TRANSCRIPTS });
    axios
      .post(`${config.api.base_url}/campaigns/${campaignId}/calls/process`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: PROCESS_CAMPAIGN_TRANSCRIPTS_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: PROCESS_CAMPAIGN_TRANSCRIPTS_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const processCampaignTranscriptsReset = () => ({
  type: PROCESS_CAMPAIGN_TRANSCRIPTS_RESET,
});

// Retry Failed Transcripts
export const retryFailedTranscriptsApi = (campaignId) => {
  return (dispatch) => {
    dispatch({ type: RETRY_FAILED_TRANSCRIPTS });
    axios
      .post(`${config.api.base_url}/campaigns/${campaignId}/calls/retry`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: RETRY_FAILED_TRANSCRIPTS_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: RETRY_FAILED_TRANSCRIPTS_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const retryFailedTranscriptsReset = () => ({
  type: RETRY_FAILED_TRANSCRIPTS_RESET,
});

// Update Call Quality
export const updateCallQualityApi = (campaignId, callId, quality) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_CALL_QUALITY });
    axios
      .patch(`${config.api.base_url}/campaigns/${campaignId}/calls/${callId}/quality`, { quality }, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: UPDATE_CALL_QUALITY_SUCCESS, response: response.data, callId, quality });
      })
      .catch((error) => {
        dispatch({ type: UPDATE_CALL_QUALITY_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const updateCallQualityReset = () => ({
  type: UPDATE_CALL_QUALITY_RESET,
});

// Get Call Audio
export const getCallAudioApi = (campaignId, callId) => {
  return (dispatch) => {
    dispatch({ type: GET_CALL_AUDIO });
    axios
      .get(`${config.api.base_url}/campaigns/${campaignId}/calls/${callId}/audio`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: GET_CALL_AUDIO_SUCCESS, response: response.data, callId });
      })
      .catch((error) => {
        dispatch({ type: GET_CALL_AUDIO_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const getCallAudioReset = () => ({
  type: GET_CALL_AUDIO_RESET,
});

// Refresh Call Item (audio or transcript)
export const refreshCallItemApi = (campaignId, callId, type) => {
  return (dispatch) => {
    dispatch({ type: REFRESH_CALL_ITEM, callId, itemType: type });
    axios
      .post(
        `${config.api.base_url}/campaigns/${campaignId}/calls/${callId}/refresh`,
        { type },
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
          },
        }
      )
      .then((response) => {
        dispatch({ type: REFRESH_CALL_ITEM_SUCCESS, response: response.data, callId, itemType: type });
      })
      .catch((error) => {
        dispatch({ type: REFRESH_CALL_ITEM_FAIL, response: error.response?.data || error.message, callId, itemType: type });
      });
  };
};

export const refreshCallItemReset = () => ({
  type: REFRESH_CALL_ITEM_RESET,
});

// Reprocess Call
export const reprocessCallApi = (campaignId, callId) => {
  return (dispatch) => {
    dispatch({ type: REPROCESS_CALL, callId });
    axios
      .post(
        `${config.api.base_url}/campaigns/${campaignId}/calls/${callId}/reprocess`,
        {},
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
          },
        }
      )
      .then((response) => {
        dispatch({ type: REPROCESS_CALL_SUCCESS, response: response.data, callId });
      })
      .catch((error) => {
        dispatch({ type: REPROCESS_CALL_FAIL, response: error.response?.data || error.message, callId });
      });
  };
};

export const reprocessCallReset = () => ({
  type: REPROCESS_CALL_RESET,
});

// Bulk Reprocess Calls
export const bulkReprocessCallsApi = (campaignId) => {
  return (dispatch) => {
    dispatch({ type: BULK_REPROCESS_CALLS });
    axios
      .post(
        `${config.api.base_url}/campaigns/${campaignId}/bulk-reprocess`,
        {},
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
          },
        }
      )
      .then((response) => {
        dispatch({ type: BULK_REPROCESS_CALLS_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: BULK_REPROCESS_CALLS_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const bulkReprocessCallsReset = () => ({
  type: BULK_REPROCESS_CALLS_RESET,
});

// Toggle Call Star
export const toggleCallStarApi = (campaignId, callId) => {
  return (dispatch) => {
    dispatch({ type: TOGGLE_CALL_STAR, callId });
    axios
      .patch(`${config.api.base_url}/campaigns/${campaignId}/calls/${callId}/star`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: TOGGLE_CALL_STAR_SUCCESS, response: response.data, callId });
      })
      .catch((error) => {
        dispatch({ type: TOGGLE_CALL_STAR_FAIL, response: error.response?.data || error.message, callId });
      });
  };
};

export const toggleCallStarReset = () => ({
  type: TOGGLE_CALL_STAR_RESET,
});

// Eleven Labs Credits
export const getElevenLabsCredits = () => ({
  type: GET_ELEVENLABS_CREDITS,
});

export const getElevenLabsCreditsSuccess = (response) => ({
  type: GET_ELEVENLABS_CREDITS_SUCCESS,
  response,
});

export const getElevenLabsCreditsFail = (response) => ({
  type: GET_ELEVENLABS_CREDITS_FAIL,
  response,
});

export const getElevenLabsCreditsReset = () => ({
  type: GET_ELEVENLABS_CREDITS_RESET,
});

export const getElevenLabsCreditsApi = () => {
  return (dispatch) => {
    dispatch(getElevenLabsCredits());
    axios
      .get(`${config.api.base_url}/integrations/elevenlabs/credits`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(getElevenLabsCreditsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getElevenLabsCreditsFail(error.response?.data || error.message));
      });
  };
};

